import { render, staticRenderFns } from "./FilterBarSortBy.vue?vue&type=template&id=4de4927d&scoped=true&"
import script from "./FilterBarSortBy.vue?vue&type=script&lang=js&"
export * from "./FilterBarSortBy.vue?vue&type=script&lang=js&"
import style0 from "./FilterBarSortBy.vue?vue&type=style&index=0&id=4de4927d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de4927d",
  null
  
)

export default component.exports